import { PLAYER_NAME_MAX_LEN } from './constants';

// Sanitization helpers (Hardening Point 8)
export function sanitizePlayerName(raw: string): string {
  if (!raw) return '';
  let s = raw.normalize('NFKC');
  // Remove control characters
  s = Array.from(s)
    .filter((char) => {
      const code = char.codePointAt(0) ?? 0;
      return !(code <= 0x1f || code === 0x7f);
    })
    .join('');
  // Collapse whitespace
  s = s.replace(/\s+/g, ' ').trim();
  // Enforce allowed charset similar to PLAYER_NAME_REGEX (defensive)
  // eslint-disable-next-line no-misleading-character-class -- intentionally allows emoji sequences and modifiers
  s = s.replace(/[^\p{L}\p{N} _\-\p{Extended_Pictographic}\u200D\uFE0F\u{1F3FB}-\u{1F3FF}]/gu, '');
  if (s.length > PLAYER_NAME_MAX_LEN) s = s.slice(0, PLAYER_NAME_MAX_LEN);
  return s;
}
